import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RoomPreferencesIcon(props: IconProps) {
    return <Icon {...props} iconKey={"room_preferences"}/>
}
